import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Accordion, Button, Card } from "react-bootstrap";
import { Fragment, useRef, useState } from "react";
import { CheckLg, GearWideConnected } from "react-bootstrap-icons";
import { saveSystemSettings } from "../../store/api/SystemSettingsAPI";

const CustomersSettings = (props) => {
    const { findSetting, findCheckedSetting } = props;
    const [pending, setPending] = useState(false);
    const settingValues = useRef({});
    const dispatch = useDispatch()
    const save = () => {
        setPending(true);
        dispatch(saveSystemSettings(settingValues.current, () => { setPending(false) }));
    }
    return (<Fragment>

        <div className="row" style={{ fontSize: "12px" }}>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("Precustomers_AddressIsRequired")}
                    onChange={e => settingValues.current.Precustomers_AddressIsRequired = e.target.checked} />&nbsp;
                <span>نشانی در ثبت مشتری بالقوه الزامی باشد.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("Precustomers_PhoneIsRequired")}
                    onChange={e => settingValues.current.Precustomers_PhoneIsRequired = e.target.checked} />&nbsp;
                <span>شماره تلفن/همراه در ثبت مشتری بالقوه الزامی باشد.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("Precustomers_JobIsRequied")}
                    onChange={e => settingValues.current.Precustomers_JobIsRequied = e.target.checked} />&nbsp;
                <span>رسته شغلی در ثبت مشتری بالقوه الزامی باشد.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("Precustomers_StatusIsRequired")}
                    onChange={e => settingValues.current.Precustomers_StatusIsRequired = e.target.checked} />&nbsp;
                <span>وضعیت در ثبت مشتری بالقوه الزامی باشد.</span>&nbsp;
            </div>

        </div>
        <Button variant="success" className="group-Btn mt-1" onClick={save} disabled={pending}>
            <>
                {pending === true ? <Loader type="BallTriangle" color="white" style={{ display: "inline-block" }} width={15} height={15} /> : <CheckLg size={18} />}
                &nbsp;ذخیره تغییرات
            </>
        </Button>
    </Fragment>)

}
export default CustomersSettings;